export const CHECKOUT_URL =
  'https://metodologia-della-ricerca-pro.impultienda.ar/checkout'

export const OFFER = {
  name: 'Metodologia della Ricerca Pro',
  price: 27,
  currency: 'EUR',
  priceLabel: '27 €',
  comparePriceLabel: '97 €',
}

export const CTA_LABEL = '🟡 VOGLIO METODOLOGIA DELLA RICERCA PRO ORA'
